<template>
  <v-form ref="addDiscountsForm" @submit.prevent v-model="valid">
    <v-card-text>
      <v-text-field
        label="Code"
        v-model="code"
        type="text"
        :rules="[required('Discount Code')]"
        hint="Code the user must enter to apply the discount"
      />

      <v-radio-group v-model="type" row>
        <v-radio color="blue darken-2" label="Amount" :value="0"></v-radio>
        <v-radio color="blue darken-2" label="Percentage" :value="1"></v-radio>
      </v-radio-group>

      <v-text-field
        v-if="type == 0"
        class="mt-2"
        @focus="$event.target.select()"
        label="Discount Amount"
        prefix="£"
        v-model="discount_amount"
        min="0"
        step=".01"
        type="number"
        :rules="rules_amount"
        hint="Amount in £ to remove from the order total"
      />

      <v-text-field
        v-if="type == 1"
        class="mt-2"
        @focus="$event.target.select()"
        label="Discount Percentage"
        suffix="%"
        v-model="discount_percentage"
        min="0"
        type="number"
        :rules="rules_percentage"
        hint="% Amount to remove from the order total"
      />

      <v-switch
        class="mt-2"
        v-model="discount_active"
        color="blue darken-2"
        inset
      >
        <template v-slot:label>
          Discount Active
          <v-icon right :color="discount_active ? 'success' : 'error'">
            {{ discount_active ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-dialog
        ref="dialog"
        v-model="start_date_dialog"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            v-model="start_date_text"
            label="From Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </template>

        <v-date-picker
          v-model="start_date"
          no-title
          v-on:change="start_date_dialog = false"
        >
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-2" @click="start_date_dialog = false"
            >Cancel</v-btn
          >
        </v-date-picker>
      </v-dialog>

      <v-dialog ref="dialog" v-model="end_date_dialog" persistent width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            v-model="end_date_text"
            label="From Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </template>

        <v-date-picker
          v-model="end_date"
          no-title
          v-on:change="end_date_dialog = false"
        >
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-2" @click="end_date_dialog = false"
            >Cancel</v-btn
          >
        </v-date-picker>
      </v-dialog>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn
        large
        type="submit"
        :loading="$store.getters.orderdiscountsLoading"
        color="blue darken-2"
        @click="submit"
        outlined
        :disabled="!valid"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "AddOrderDiscount",

  data: () => {
    return {
      valid: false,

      type: 0,

      code: null,
      discount_percentage: "",
      discount_amount: "",
      discount_active: true,
      start_date: null,
      end_date: null,

      start_date_dialog: false,
      end_date_dialog: false,

      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },

      rules_percentage: [
        (v) => /^\d*(\.\d{1,2})?$/.test(v) || "Invalid Amount Entered",
        (v) => (v < 100 && v != null) || `Maximum percentage 100`,
        (v) => Number.isInteger(Number(v)) || `Value must be an integer`,
      ],

      rules_amount: [
        (v) => /^\d*(\.\d{1,2})?$/.test(v) || "Invalid Amount Entered",
        (v) => (v < 10000 && v != null) || `Maximum value £9,999`,
      ],
    };
  },

  computed: {
    start_date_text() {
      console.log("START DATE");
      console.log(this.start_date);
      console.log(moment(this.start_date));
      console.log(moment(this.start_date, "YYYY-MM-DD"));
      return this.start_date
        ? moment(this.start_date, "YYYY-MM-DD").format("dddd, MMMM Do YYYY")
        : "";
    },

    end_date_text() {
      return this.end_date
        ? moment(this.end_date).format("dddd, MMMM Do YYYY")
        : "";
    },
  },

  methods: {
    ...mapActions(["addDiscount"]),

    momentFormatDate(date) {
      return date ? moment(date).format("dddd, MMMM Do YYYY") : "";
    },

    async submit() {
      console.log("Amend Row");

      if (this.type == 0) {
        //Amount type ensure percentage is 0
        this.discount_percentage = 0;
      } else {
        //Percentage type ensure amount is 0
        this.discount_amount = 0;
      }

      let data = {
        code: this.code,
        discount_percentage: this.discount_percentage
          ? this.discount_percentage
          : null,
        discount_amount: this.discount_amount ? this.discount_amount : null,
        discount_active: this.discount_active ? 1 : 0,
        start_date: this.start_date ? this.start_date : null,
        end_date: this.end_date ? this.end_date : null,
      };

      let result = await this.addDiscount(data);

      if (result) {
        this.$router.push({ name: "MaintenanceOrderdiscounts" });

        this.code = null;
        this.discount_percentage = "";
        this.discount_amount = "";
        this.discount_active = true;
        this.start_date = null;
        this.end_date = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>